export default __webpack_public_path__ + "static/media/WStore_Icon_Atmore.2b4f9050.png";